// Date display helpers. Portal-wide format: "21 Dec 2026".
// Inputs (<input type="date">) still use ISO YYYY-MM-DD — these helpers are
// only for read-only display surfaces.

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

/** "21 Dec 2026" — accepts "YYYY-MM-DD", ISO datetime, or Date. Returns "" / placeholder when blank. */
export function fmtDate(value, placeholder = "—") {
  if (!value) return placeholder;
  let d;
  if (value instanceof Date) {
    d = value;
  } else if (typeof value === "string") {
    // Pure date string — avoid timezone shift by parsing parts directly.
    const m = /^(\d{4})-(\d{2})-(\d{2})(?:[ T]|$)/.exec(value);
    if (m) {
      const day = parseInt(m[3], 10);
      const mon = parseInt(m[2], 10) - 1;
      const yr = parseInt(m[1], 10);
      if (mon < 0 || mon > 11) return placeholder;
      return `${String(day).padStart(2, "0")} ${MONTHS[mon]} ${yr}`;
    }
    d = new Date(value);
  } else {
    d = new Date(value);
  }
  if (!d || isNaN(d.getTime())) return placeholder;
  return `${String(d.getDate()).padStart(2, "0")} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
}

/** "21 Dec 2026, 03:45 PM" for timestamps. */
export function fmtDateTime(value, placeholder = "—") {
  if (!value) return placeholder;
  const d = value instanceof Date ? value : new Date(value);
  if (!d || isNaN(d.getTime())) return placeholder;
  const day = `${String(d.getDate()).padStart(2, "0")} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
  let hr = d.getHours();
  const min = String(d.getMinutes()).padStart(2, "0");
  const ampm = hr >= 12 ? "PM" : "AM";
  hr = hr % 12 || 12;
  return `${day}, ${String(hr).padStart(2, "0")}:${min} ${ampm}`;
}
